import { AdminNavRouteStaticDataType } from './types';
import { NAVIGATION_ADMIN_MENU_LIST } from './enums';
import { DefaultTabEnabledMap } from './constants';

export const getAdminIsTabEnabledMap = (navConfig: AdminNavRouteStaticDataType[]) => {
  let tabMap = { ...DefaultTabEnabledMap };

  if (navConfig && navConfig.length > 0) {
    const navIdMap: Record<string, boolean> = {};
    navConfig.forEach(item => {
      navIdMap[item.id] = true;
    });

    tabMap = {
      trainingEnabled: !!navIdMap[NAVIGATION_ADMIN_MENU_LIST.TRAINING],
      assetsEnabled: !!navIdMap[NAVIGATION_ADMIN_MENU_LIST.ASSETS],
      analyticsEnabled: !!navIdMap[NAVIGATION_ADMIN_MENU_LIST.ANALYTICS],
      dsrEnabled: !!navIdMap[NAVIGATION_ADMIN_MENU_LIST.DSR],
      callAIEnabled: !!navIdMap[NAVIGATION_ADMIN_MENU_LIST.CALL_AI],
      settingsEnabled: !!navIdMap[NAVIGATION_ADMIN_MENU_LIST.ACCOUNT_SETTINGS],
      contentEnabled: !!navIdMap[NAVIGATION_ADMIN_MENU_LIST.CONTENT_CENTER],
      usersEnabled: !!navIdMap[NAVIGATION_ADMIN_MENU_LIST.USERS],
    };
  }

  return tabMap;
};
